export const FETCH_INSTRUCTOR_COURSE_DETAIL_INITIAL = "FETCH_INSTRUCTOR_COURSE_DETAIL_INITIAL";
export const FETCH_INSTRUCTOR_COURSE_DETAIL_SUCCESS = "FETCH_INSTRUCTOR_COURSE_DETAIL_SUCCESS";
export const FETCH_INSTRUCTOR_COURSE_DETAIL_FAILURE = "FETCH_INSTRUCTOR_COURSE_DETAIL_FAILURE";


